var React = require('react');

function CardImage (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z","key":0}),React.createElement("path",{"d":"M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z","key":1})]);
}

CardImage.defaultProps = {"fill":"currentColor","className":"bi bi-card-image","viewBox":"0 0 16 16"};

module.exports = CardImage;

CardImage.default = CardImage;
